"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.fetchThingTypesInCategory = fetchThingTypesInCategory;
exports.thingTypesInCategory = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _fetchGql = require("../../../../../coffee/graphql/fetchGql"); //TODO: order?
//   this.tipsData = orderBy(this.tipsData, ["thingTypeName", "title"], ["asc", "asc"]);


var thingTypesInCategory = "\nquery thingTypesInCategory($categoryId: Int) {\n  allCategories(condition: {id: $categoryId}) {\n    edges {\n      node {\n        name\n      }\n    }\n  }\n  allThingTypes(condition: {categoryId: $categoryId}) {\n    edges {\n      node {\n        id\n        name\n        brief\n        url\n      }\n    }\n  }\n  allTips(condition: { categoryId: $categoryId}) {\n    edges{\n      node {\n        id\n        title\n        description\n        thingTypeByThingTypeId {\n          name\n          url\n        }\n      }\n    }\n  }\n}\n";
exports.thingTypesInCategory = thingTypesInCategory;

function fetchThingTypesInCategory(_x) {
  return _fetchThingTypesInCategory.apply(this, arguments);
}

function _fetchThingTypesInCategory() {
  _fetchThingTypesInCategory = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee(categoryId) {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _fetchGql.getGqlData)({
              query: thingTypesInCategory,
              variables: {
                categoryId: categoryId
              }
            });

          case 2:
            return _context.abrupt("return", _context.sent);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchThingTypesInCategory.apply(this, arguments);
}